export enum Environment {
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
}
